/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


export default
{
  Dashboard:          '/',

  DashboardBoard:     '/dashboard/board/:id',
  DashboardInfluence: '/dashboard/board/:id/influence',
  DashboardColony:    '/dashboard/colony/:id',
  DashboardAttach:    '/dashboard/board/:id/attach/:colony',

  Deploy:             '/deploy/:id',

  Overview:           '/overview',
  SectorGenerator:    '/sector.generator',

  Terms:              '/terms',
  Privacy:            '/privacy',
};
